import script from "./ConfirmacionAppModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmacionAppModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmacionAppModal.vue?vue&type=style&index=0&id=1f0892da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0892da"]])

export default __exports__